export function formatAttributeLabel(entry: {
    key: string;
    label: string;
    isSystem: boolean;
}): string {
    if (!entry.isSystem) {
        return entry.label;
    }

    switch (entry.key) {
        case 'logo':
            return gettext('ATTRIBUTE_BUILTIN_LOGO');
        case 'map':
            return gettext('ATTRIBUTE_BUILTIN_MAP');
        case 'installation_images':
            return gettext('ATTRIBUTE_BUILTIN_INSTALLATION_IMAGES');
        case 'notes':
            return gettext('ATTRIBUTE_BUILTIN_NOTES');
        default:
            return entry.label;
    }
}

export function getAttributeDisplayLabels<
    Entry extends { definitionId: string; valueType: string }
>(entries: readonly Entry[], getLabel: (entry: Entry) => string): string[] {
    // Compare labels after translation, including custom labels that match a built-in one.
    const labels = entries.map(getLabel);
    const counts = new Map<string, number>();
    const identities = entries.map((entry, index) =>
        JSON.stringify([entry.valueType, labels[index]])
    );

    identities.forEach((identity) => counts.set(identity, (counts.get(identity) ?? 0) + 1));

    return entries.map((entry, index) =>
        counts.get(identities[index]) === 1
            ? labels[index]
            : `${labels[index]} (#${entry.definitionId})`
    );
}
